import React, { Fragment, useEffect, useState } from 'react'
import { IFile, IReport } from '../../helpers/Interfaces'
import { downloadMedia, getDocumentMedia } from '../../helpers/FirebaseFunctions'
import Loading from '../Loading/Loading'
import { convertDuration, formatMB } from '../../helpers/HelperFunctions'
import Download from "../../assets/images/Download.svg";
import File from "../../assets/images/File.svg";

type UploadedFilesProps = {
    selectedDocument: IReport
}

function UploadedFiles(props: UploadedFilesProps) {

    const [media, setMedia] = useState([] as IFile[]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getMedia(props.selectedDocument.mediaId);
    }, [props.selectedDocument.mediaId])

    async function getMedia(mediaId: string) {
        setLoading(true);
        await getDocumentMedia(mediaId, setMedia)
        setLoading(false);
    }

    const downloadFile = async (url: string, fileName: string) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error(`Failed to download ${fileName}:`, error);
        }
    };

    async function handleDownload() {
        await Promise.all(media.map((file) => downloadFile(file.fileUrl, file.fileName)));
    }

    function uploadedFilesView() {

        if (loading) {
            return (<Loading color='black' />)
        }

        return (<div className="uploaded-files-content">
            <div className='download-all-wrapper' onClick={handleDownload}>Download All</div>
            <div className="uploaded-files-document">
                {media.map((file: IFile) => {
                    return file.fileExtension.includes("image")
                        ? (<Fragment />)
                        : (<div key={file.fileUrl} className="file-content">
                            <div className="file-data">
                                <img src={File} alt="File" />
                                <label className="file-name">{file?.fileName}</label>
                            </div>
                            <div className="file-properties">
                                {file?.duration != 0
                                    ? <span className="duration">{convertDuration(file?.duration)}</span>
                                    : <Fragment />
                                }
                                <span className="size">{formatMB(file?.fileSize)}</span>
                                <img onClick={() => downloadMedia({ fileName: file.fileId, downloadingName: file.fileName })} src={Download} alt="Trash" />
                            </div>
                        </div>)
                })}
            </div>
            <div className="uploaded-files-images">
                {media.map((file: IFile) => {
                    return file.fileExtension.includes("image")
                        ? (<div key={file.fileUrl} className="img-uploaded">
                            <img className='img' src={file?.fileUrl} alt="File" />
                            <span className="delete-content download">
                                <img onClick={() => downloadMedia({ fileName: file.fileId, downloadingName: file.fileName })} src={Download} alt="Trash" />
                            </span>
                        </div>)
                        : (<Fragment />)
                })}
            </div>
        </div>)
    }

    return (
        <div className='view-document-body uploaded-files'>
            {uploadedFilesView()}
        </div>
    )
}

export default UploadedFiles